if (!customElements.get('age-verification')) {
  class AgeVerification extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.js-age-verify-checkbox');
      if (!this.checkbox) return;

      // Find the checkout button within the same container (works for both
      // the cart drawer and the main cart page layouts).
      this.checkoutBtn = this.parentElement
        ? this.parentElement.querySelector('button[name="checkout"]')
        : null;

      if (this.checkoutBtn) {
        // Disable until the shopper explicitly confirms their age.
        this.checkoutBtn.disabled = true;

        this.changeHandler = () => {
          this.checkoutBtn.disabled = !this.checkbox.checked;
        };

        this.checkbox.addEventListener('change', this.changeHandler);
      }
    }

    disconnectedCallback() {
      if (this.checkbox && this.changeHandler) {
        this.checkbox.removeEventListener('change', this.changeHandler);
      }
    }
  }

  customElements.define('age-verification', AgeVerification);
}
